class FilterStore {
    constructor() {
        this.price = { min: '', max: '' };
        this.square = { min: '', max: '' };
        this.floor = { min: '', max: '' };
        this.room = { min: '', max: '' };
        this.bedroom = { min: '', max: '' };
        this.areas = [];
        this.buildings = [];
        this.repairs = [];
        this.heatings = [];
        this.parkings = [];
        this.rules = ['base'];
    }

    setPrice(priceRange) {
        this.price = priceRange;
    }

    setSquare(squareRange) {
        this.square = squareRange;
    }

    setFloor(floorRange) {
        this.floor = floorRange;
    }

    setRoom(roomRange) {
        this.room = roomRange;
    }

    setBedroom(bedroomRange) {
        this.bedroom = bedroomRange;
    }

    setAreas(areas) {
        this.areas = areas;
    }

    setBuildings(buildings) {
        this.buildings = buildings;
    }

    setRepairs(repairs) {
        this.repairs = repairs;
    }

    setHeatings(heatings) {
        this.heatings = heatings;
    }

    setParkings(parkings) {
        this.parkings = parkings;
    }

    setRules(rules) {
        this.rules = rules;
    }
}

export default FilterStore;
